import script from "./PersonalPages.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalPages.vue?vue&type=script&setup=true&lang=js"

import "./PersonalPages.vue?vue&type=style&index=0&id=146030e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146030e6"]])

export default __exports__